import React from 'react';
import styled from 'styled-components';
import { useProjectImage } from '../../Module/Project/Presentation/useProjectImage';

interface ProjectImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  idOrUrl?: string;
  fallback?: string;
}

const ProjectImage: React.FC<ProjectImageProps> = ({ idOrUrl, fallback, ...props }) => {
  const { url, loading } = useProjectImage(idOrUrl);

  if (loading) {
    return <ImagePlaceholder {...(props as any)} />;
  }

  return <img src={url || fallback} alt={props.alt || ''} {...props} />;
};

const ImagePlaceholder = styled.div`
  background: #f0f1f2;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default ProjectImage;
